export default __webpack_public_path__ + "static/media/RU.9a9983eb.svg";